import React, { memo, useMemo } from 'react';
import CountUp from 'react-countup';
import { Card, CardBody, Media } from 'reactstrap';
import { WidgetProps } from '../types';
import { WidgetIcons } from '../BaseWidget';
import { durationHumanizeReports } from '@core/utils/time';
import { StatResultResponse } from '@business/entities/dashboard';

export const StatWidget = memo((props: WidgetProps<StatResultResponse>) => {
  const { settings, result } = props;
  const content = useMemo(() => {
    if (result?.label == 'd') {
      return <span>{durationHumanizeReports((result?.value || 0) * 60)}</span>;
    } else if (result?.label == 'h') {
      return <span>{durationHumanizeReports((result?.value || 0) * 60, { units: ['h'] })}</span>;
    } else if (result?.label == 'm') {
      return <span>{durationHumanizeReports((result?.value || 0) * 60, { units: ['m'] })}</span>;
    }
    return (
      <CountUp
        separator=","
        preserveValue
        end={result?.value ?? 0}
        duration={1}
        decimals={result?.decimal || 0}
        prefix={result?.label == '%' ? '' : result?.label || ''}
        suffix={(result?.label == '%' ? '%' : '') || ''}
      ></CountUp>
    );
  }, [result]);

  return (
    <Card style={{ marginBottom: 0, flex: 1 }}>
      <CardBody>
        <Media>
          <Media body>
            <p className="text-muted fw-medium d-flex align-items-center flex-row">
              {settings.title || 'Stats'}
              <WidgetIcons {...props} />
            </p>
            <h4 className="mb-0">{content}</h4>
          </Media>
        </Media>
      </CardBody>
    </Card>
  );
});
